import { useContext } from "react";
import SessionContext from "./SessionContext";

export default function useSession() {
    return useContext(SessionContext);
}